import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

interface EnvironmentsTextProps extends Omit<TypographyProps, 'component'> {
  size?: 'small' | 'medium' | 'large' | 'xlarge';
}

const EnvironmentsText: React.FC<EnvironmentsTextProps> = ({
  size = 'medium',
  sx,
  ...props
}) => {
  const sizeMap = {
    small: { fontSize: '1.5rem', lineHeight: 1.2 },
    medium: { fontSize: '2rem', lineHeight: 1.2 },
    large: { fontSize: '3rem', lineHeight: 1.1 },
    xlarge: { fontSize: '4rem', lineHeight: 1.1 }
  };

  const selectedSize = sizeMap[size];

  return (
    <Typography
      variant="h1"
      sx={{
        fontSize: selectedSize.fontSize,
        lineHeight: selectedSize.lineHeight,
        fontWeight: 700,
        textTransform: 'lowercase',
        color: '#FFFFFF', // White
        margin: 0,
        letterSpacing: '0.05em',
        textShadow: '0 1px 2px rgba(0,0,0,0.1)',
        fontFamily: 'Inter, system-ui, sans-serif',
        display: 'flex',
        alignItems: 'center',
        ...sx
      }}
      {...props}
    >
      Environments
    </Typography>
  );
};

export default EnvironmentsText;
